const LIST_QUERY = `
  query ListUsers($searchTerm: String, $includeInactive: Boolean, $paginationParams: PaginationInput!) {
    listUsers(
      searchCriteria: $searchTerm,
      includeInactive: $includeInactive,
      pagination: $paginationParams) {
      objects {
        username
        firstName
        lastName
        email
        phoneNumber
        hasPin
        hasFingerData
        isActive
        roles {
          name
          description
        }
        cards {
          uuid
          isBypass
        }
        groups {
          uuid
          name
        }
      }
      totalRows
    }
  }
`
const CREATE_MUTATION = `
  mutation CreateUser(
    $username: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $email: String!
    $phoneNumber: String
    $bio: String!
    $role: UserRoleType
  ) {
    createUser(params: {
      username: $username,
      password: $password,
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      phoneNumber: $phoneNumber,
      bio: $bio,
      role: $role
    }) {
      username
      firstName
      lastName
    }

  }
`

const UPDATE_MUTATION = `
  mutation UpdateUser(
    $username: String!
    $firstName: String
    $lastName: String
    $email: String
    $phoneNumber: String
    $role: UserRoleType
  ) {
    updateUser(params: {
      username: $username,
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      phoneNumber: $phoneNumber,
      role: $role
    }) {
      username
    }
  }
`

const DELETE_MUTATION = `
  mutation DeleteUser($username: String!) {
    deleteUser(username: $username)
  }
`

const ENROLL_USER = `
  mutation EnrollBCIDUser($username: String!) {
    bcidEnroll(username: $username)
  }
`

const DELETE_USER_PINS = `
  mutation DeleteUserPins($username: String!) {
    deleteUserPins(username: $username)
  }
`

const DELETE_USER_FINGER_TEMPLATES = `
  mutation DeleteUserFingerTemplates($username: String!) {
    deleteUserFingerTemplates(username: $username)
  }
`

const userQueries = {
  methods: {
    async listUsersQuery(paginationParams, searchTerm, includeInactive) {
      try {
        const result = await this.graphQuery(LIST_QUERY, {
          searchTerm,
          includeInactive,
          paginationParams,
        })
        const {objects: userList, totalRows} = result.listUsers
        return {userList, totalRows}
      } catch (error) {
        throw new Error(error)
      }
    },
    async createUserMutation(userInfo) {
      try {
        const result = await this.graphQuery(CREATE_MUTATION, userInfo)
        return result.createUser
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateUserMutation(userInfo) {
      userInfo.phoneNumber = this.isEmptyString(userInfo.phoneNumber)
        ? 'null'
        : userInfo.phoneNumber
      try {
        const result = await this.graphQuery(UPDATE_MUTATION, userInfo)
        return result.updateUser
      } catch (error) {
        throw new Error(error)
      }
    },
    async deleteUserMutation(username) {
      try {
        const result = await this.graphQuery(DELETE_MUTATION, {username})
        return result.deleteMutation
      } catch (error) {
        throw new Error(error)
      }
    },
    async enrollUserAuthentication(username) {
      try {
        const result = await this.graphQuery(ENROLL_USER, {username})
        return result.enrollUser
      } catch (error) {
        throw new Error(error)
      }
    },
    async deleteUserPins(username) {
      try {
        const result = await this.graphQuery(DELETE_USER_PINS, {username})
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async deleteUserFingerTemplates(username) {
      try {
        const result = await this.graphQuery(DELETE_USER_FINGER_TEMPLATES, {username})
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default userQueries
